import {getURLQueryFromObject} from '@netx/core-utils';
import {type IAsset} from '../schema';
import {RequireAtLeastOne} from 'type-fest';

export const getAssetImageUrl = (
	asset?: Pick<IAsset, 'assetId' | 'jwt' | 'moddate'> &
		RequireAtLeastOne<Pick<IAsset, 'thumbUrl' | 'previewUrl' | 'zoomUrl'>>,
	options: {
		size?: 'thumb' | 'preview' | 'zoom';
		queryParams?: Record<string | number, string | number>;
	} = {},
): string => {
	if (!asset) return '';

	let size = options.size || 'thumb';
	const queryParams = options.queryParams || {};
	queryParams.moddate = asset.moddate;

	// if we are looking for zoom (1000px) and it is not set - we will fallback to preview
	if (size === 'zoom' && !asset.zoomUrl) size = 'preview';

	// "sass"
	if (asset.jwt) {
		// we will not be supporting any cache busting [at this moment]
		switch (size) {
			case 'preview':
				return asset.previewUrl ? `${asset.previewUrl}?jwt=${asset.jwt}` : '';
			case 'zoom':
				return asset.zoomUrl ? `${asset.zoomUrl}?jwt=${asset.jwt}` : '';
			default:
				return asset.thumbUrl ? `${asset.thumbUrl}?jwt=${asset.jwt}` : '';
		}
	}
	// "on-prem"
	else {
		// we will still be supporting any cache busting for these
		const appendToSrc = getURLQueryFromObject(queryParams);
		switch (size) {
			case 'preview':
				return asset.previewUrl ? `${asset.previewUrl}${appendToSrc}` : '';
			case 'zoom':
				return asset.zoomUrl ? `${asset.zoomUrl}${appendToSrc}` : '';
			default:
				return asset.thumbUrl ? `${asset.thumbUrl}${appendToSrc}` : '';
		}
	}
};
